import { createStore, applyMiddleware, compose } from 'redux';
import { createMiddleware as createAnalyticsMiddleware } from 'redux-beacon';
import { createEpicMiddleware } from 'redux-observable';
import thunk from 'redux-thunk';
import * as storage from 'redux-storage';
import createEngine from 'redux-storage-engine-sessionstorage';
import debounce from 'redux-storage-decorator-debounce';
import filter from 'redux-storage-decorator-filter';
import { RootReducer, RootEpic } from './root.reducer';
import { createCatchMiddleware } from './create-catch.middleware';

//Analytics Imports
import { GoogleAnalytics } from 'redux-beacon/targets/google-analytics';
import { analyticsLogger } from 'redux-beacon/extensions/logger';
import { HistoryAnalytics } from './history/history.analytics';
import { FavouriteAnalytics } from './favourite/favourite.analytics';
import { SearchAnalytics } from './search/search.analytics';
import { AssetsAnalytics } from './assets/assets.analytics';
import { TableColmunsAnalytics } from './table-columns/table-colmuns.analytics';
import { AttributesAnalytics } from './attributes/attributes.analytics';
import { securityGroupsAnalytics } from './security/security.analytics';
import { CombinedBlackListKeys, CombinedWhiteListKeys } from './state.saved.keys';

export const StorageEngine = debounce(
  filter(createEngine('onei3-state'), CombinedWhiteListKeys, CombinedBlackListKeys),
  1500
);
const errorHandler = (error, state, action, dispatch) => {
  console.error(error);
  //todo log error to Api
};
class Store {
  constructor() {
    this.store = null;
  }

  create() {
    const analyticsMiddleware = createAnalyticsMiddleware(
      {
        ...HistoryAnalytics,
        ...FavouriteAnalytics,
        ...SearchAnalytics,
        ...AssetsAnalytics,
        ...TableColmunsAnalytics,
        ...AttributesAnalytics,
        ...securityGroupsAnalytics
      },
      events => {
        // console.log(' These are the events you seek David: ', events);
        // GoogleAnalytics(events);
      },
      { analyticsLogger }
    );

    const storageMiddleware = storage.createMiddleware(StorageEngine);
    const epicMiddleware = createEpicMiddleware();
    //midleware to catch reduce error so wont reach epics then terminate them
    const catchMiddleware = createCatchMiddleware(errorHandler);

    let middleware =
      process.env.NODE_ENV === 'testing'
        ? [thunk, catchMiddleware, epicMiddleware, storageMiddleware]
        : [thunk, catchMiddleware, epicMiddleware, analyticsMiddleware, storageMiddleware];

    let composeEnhancers = compose;

    if (process.env.NODE_ENV === 'local' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }

    // Merge our application reducers with the required storage-sync reducer
    const finalRootReducer = storage.reducer(RootReducer);

    this.store = createStore(finalRootReducer, composeEnhancers(applyMiddleware(...middleware)));

    epicMiddleware.run(RootEpic);

    return this.store;
  }

  loadFromStorage() {
    const storageLoader = storage.createLoader(StorageEngine);
    //load saved state/store from the storage
    storageLoader(this.store);
  }
}

export default new Store();
